import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Tooltip from "@material-ui/core/Tooltip";
import { Link, useParams, useLocation } from "react-router-dom";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { app } from "../firebase";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    marginLeft: "var(--sidebar-width, 0px)",
    transition: "margin-left .2s ease",
    "@media (max-width: 700px)": {
      marginLeft: 0,
    },
  },
  tab: {
    fontSize: 12,
    color: "#5f6368",
    textTransform: "capitalize",
    height: 10,
    fontWeight: 600,
    fontFamily: "Google sans,Roboto,Arial,sans-serif",
  },
  disabledTab: {
    opacity: "0.45 !important",
    cursor: "not-allowed !important",
    pointerEvents: "auto !important",
  },
  tabs: {
    height: 10,
  },
});

function CenteredTab({ isPublished: propIsPublished }) {
  const { id } = useParams();
  const location = useLocation();
  const classes = useStyles();
  const [isPublished, setIsPublished] = useState(
    propIsPublished !== undefined ? propIsPublished : false
  );

  useEffect(() => {
    if (propIsPublished !== undefined) {
      setIsPublished(Boolean(propIsPublished));
    } else if (id) {
      const db = getFirestore(app);
      getDoc(doc(db, "forms", id))
        .then((snap) => {
          if (snap.exists()) {
            const data = snap.data();
            setIsPublished(Boolean(data?.activate));
          } else {
            setIsPublished(false);
          }
        })
        .catch(() => setIsPublished(false));
    }
  }, [propIsPublished, id]);

  // Determine the initial tab value based on the current URL
  const getInitialTabValue = (pathname) => {
    if (pathname.includes("/responses")) {
      return 1;
    }
    return 0;
  };

  const [value, setValue] = useState(getInitialTabValue(location.pathname));

  useEffect(() => {
    setValue(getInitialTabValue(location.pathname));
  }, [location.pathname]);

  const handleChange = (event, newValue) => {
    if (newValue === 1 && !isPublished) {
      return;
    }
    setValue(newValue);
  };

  return (
    <div>
      <Paper className={classes.root}>
        <Tabs
          value={value}
          onChange={handleChange}
          className={classes.tabs}
          textColor="primary"
          indicatorColor="primary"
          centered
        >
          <Tab
            label="Questions"
            className={classes.tab}
            component={Link}
            to={`/form/${id}`}
          />
          {isPublished ? (
            <Tab
              label="Responses"
              className={classes.tab}
              component={Link}
              to={`/form/${id}/responses`}
            />
          ) : (
            <Tooltip title="Publish the form first to view responses" arrow>
              <span>
                <Tab
                  label="Responses"
                  className={`${classes.tab} ${classes.disabledTab}`}
                  disabled
                />
              </span>
            </Tooltip>
          )}
        </Tabs>
      </Paper>
    </div>
  );
}

export default CenteredTab;
